<template>
	<div class="share-betslip">
		<div class="share-betslip__closed">
			<b-button
				class="share-betslip__closed__button betslip__details__button button"
				:class="{
					'no-bg': type != 'fill',
					disabled: disabled,
					full: type == 'full',
				}"
				@click="shareBet($event)"
				:disabled="disabled"
				:loading="sharingBet"
			>
				<svg
					class="share-betslip__closed__button__icon"
					v-show="!sharingBet"
					width="12px"
					viewBox="0 0 12 11"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.8125 3.95312C11.9297 4.07031 12 4.21094 12 4.375C12 4.5625 11.9297 4.70312 11.8125 4.79688L7.6875 8.35938C7.54688 8.47656 7.40625 8.52344 7.26562 8.5C7.125 8.5 6.98438 8.42969 6.89062 8.33594C6.79688 8.24219 6.75 8.10156 6.75 7.9375V5.875C5.46094 5.89844 4.47656 6.03906 3.82031 6.27344C3.07031 6.55469 2.57812 7 2.39062 7.63281C2.17969 8.26562 2.25 9.13281 2.60156 10.2344C2.64844 10.375 2.625 10.4688 2.55469 10.5625C2.48438 10.6562 2.39062 10.7266 2.27344 10.75C2.15625 10.7734 2.03906 10.75 1.94531 10.6562C1.38281 10.2812 0.9375 9.76562 0.585938 9.10938C0.1875 8.42969 0 7.75 0 7.04688C0 5.40625 0.65625 4.25781 1.96875 3.55469C3 3.01562 4.59375 2.73438 6.75 2.6875V0.8125C6.75 0.671875 6.79688 0.53125 6.89062 0.4375C6.98438 0.34375 7.125 0.273438 7.26562 0.25C7.40625 0.25 7.54688 0.296875 7.6875 0.390625L11.8125 3.95312Z"
					/>
				</svg>

				<span
					v-show="!sharingBet"
					class="share-betslip__closed__button__title"
					>{{ shareButtonText }}</span
				>
			</b-button>
		</div>

		<bottom-sheet
			v-if="shareCode && canShowBottomSheet"
			@has-mounted="showBottomSheet"
			@close="closeBottomSheet"
			ref="bottomSheet"
		>
			<div class="share-betslip__open">
				<social-links
					class="share-betslip__socials"
					:social-urls="socialUrls"
				/>
				<b-input
					class="share-betslip__input"
					type="text"
					name="sharing-code"
					readonly
					:value="shareLink"
				/>
				<b-button
					class="share-betslip__button button button__primary full"
					@click="copyCodeToClipboard"
				>
					Copy Link
				</b-button>
			</div>
			<b-button class="button full no-bg" @click="closeBottomSheet"
				>Cancel</b-button
			>
		</bottom-sheet>
	</div>
</template>
<script>
import SocialLinks from "./SocialLinks.vue";
export default {
	name: "ShareBetslip",
	components: { SocialLinks },
	props: {
		shareButtonText: {
			type: String,
			default: "Share",
			required: false,
		},
		productType: {
			type: String,
			required: true,
		},
		bets: {
			type: Array,
			default: () => [],
		},
		betId: {
			type: String || Number,
			default: null,
		},
		profileId: {
			type: String || Number,
			default: null,
		},
		token: {
			type: String,
			default: null,
		},
		type: {
			type: String,
			default: "line",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			canShowBottomSheet: false,
			sharingBet: false,
			changedMatches: [],
			shareCode: null,
			socialUrls: null,
		};
	},
	mounted() {
		this.$emit("mounted");
	},
	methods: {
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		copyCodeToClipboard() {
			this.$copyText(this.socialUrls.copy).then(
				(e) => {
					this.$notifications.add({
						message: "Copied the code successfully",
						title: "Success",
						type: "success",
						duration: 5000,
					});
				},
				(e) => {
					this.$notifications.add({
						message: "Unable to copy, please try again",
						title: "Failed",
						type: "error",
						duration: 5000,
					});
				}
			);
		},
		shareBet(e) {
			if (this.sharingBet || this.disabled) return;
			let vm = this;
			let bets = vm.bets;
			vm.sharingBet = true;

			if (bets.length == 0 && !vm.betId) {
				vm.sharingBet = false;
				return;
			}

			// Map betslip to endpoint requirements
			let betslip = this.bets.map((bet) => {
				return {
					odd_key: bet.odd.odd_key,
					outcome_id: bet.odd.outcome_id || 0,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.parent_match_id || "",
					sub_type_id: bet.sub_type_id,
					has_parent: bet.is_shared || null,
					parent_code: bet.share_code || null,
				};
			});

			// Build payload
			let payload = {
				profile_id: vm.profileId,
				bet_id: vm.betId,
				token: vm.token,
				src: "MOBILE_WEB",
				product_type: vm.productType,
				betslip: betslip,
			};

			this.$axios
				.post(`${BASE_V2_URL}share/encode`, payload)
				.then((response) => {
					console.log(response);
					vm.shareCode = response.data.code;
					vm.shareLink = response.data.link;
					vm.socialUrls = response.data.meta.social_urls;
					vm.sharingBet = false;
					vm.$nextTick(() => {
						vm.canShowBottomSheet = true;
					});
				})
				.catch((error) => {
					vm.placeBetButton = "Share Betslip";
					vm.sharingBet = false;
					let errorMessage = "An error occurred. Please try again";
					if (error.response) errorMessage = error.response.data.message;

					vm.$notifications.add({
						message: errorMessage,
						title: "Failed to share betslip",
						type: "error",
						duration: 5000,
					});
				});
		},
	},
};
</script>
<style lang="scss">
.share-betslip {
	&__closed {
		&__button {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			background: none;
			border: none;
			border-radius: 4px;
			padding: 8px;
			font-size: var(--font-small);
			margin-right: 5px;
			color: var(--black) !important;
			&__icon {
				margin-right: 3px;
				fill: var(--black);
			}
			&__title {
				font-weight: var(--font-weight-medium);
			}

			&.disabled {
				pointer-events: none;
				border: none;
				color: var(--light-gray) !important;
				.share-betslip__closed__button__icon path {
					fill: var(--light-gray) !important;
				}
				box-shadow: none;
			}
		}
	}
	&__open {
		padding: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.modal {
		&--active {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&__container {
			display: flex;
			flex-direction: column;
			align-items: center;
			border-radius: 4px;
			padding: 16px 10px;
			max-width: 768px;
			&-links {
				margin-bottom: 10px;
			}
		}
	}
	.input-sharing-code {
		background-color: var(--light-gray);
		border: 1px solid var(--light-gray);
		color: var(--black);
		text-align: center;
		margin-bottom: 10px;
		width: 80%;
		font-size: var(--font-large);
	}

	.copy-button {
		width: 100%;
		background-color: var(--yellow);
		border: none;
		font-weight: var(--font-weight-medium);
		text-transform: uppercase;
		color: var(--black);
		border-radius: 4px;
		padding: 8px 16px;
		font-size: var(--font-medium);
	}
	&__socials {
		margin-bottom: 10px;
	}
	&__input {
		margin-bottom: 10px;
		width: 100%;
		input {
			font-size: var(--font-small) !important;
			text-align: center;
		}
	}
	&__button {
	}
}
</style>
